import isNil from 'lodash/isNil';
import navigate from 'libs/router/navigate';
import { sanitizeUrl } from '@braintree/sanitize-url';

import { isUserLoggedIn } from './session';
import { getDefaultOrganizationUrl } from './navigation';
import { Querystring } from './url';
import { isAdmin } from './account';

import type {
  Account,
  DeliverablesFilterCampaign,
  LocationDeprecated,
  LocationWindow,
  Organization,
  Role
} from 'types';
import type { State } from '../types/State.type';

export function generateRedirectRoute(
  currentAccount: Account | undefined | null,
  currentOrganization: Organization,
  location: LocationWindow,
  roles: Array<Role>
): string {
  const { query } = location;

  // so called "point back route"
  if (query && query.next) {
    const sanitized = sanitizeUrl(query.next);
    return sanitized === 'about:blank' ? '/' : sanitized;
  }

  if (currentAccount && isAdmin(currentAccount, roles)) {
    return '/admin';
  }

  return getDefaultOrganizationUrl(currentOrganization);
}

export function redirectToLoginPage(nextRoute: string | undefined | null = null): void {
  let nextLocationUrl = '/login';

  if (nextRoute) {
    nextLocationUrl += `?next=${sanitizeUrl(nextRoute)}`;
  }

  navigate.to(nextLocationUrl);
}

export function redirectToMainPage(state: State): void {
  const { currentAccount } = state.account;
  const { currentOrganization } = state.organizations;
  const { roles } = state.account;
  const currentLocation = window.currentLocation;

  if (isUserLoggedIn(currentAccount) && isNil(currentOrganization)) {
    navigate.to('/user/settings');

    return;
  }

  const mainPageRoute = isUserLoggedIn(currentAccount) && !isNil(currentOrganization) ?
    generateRedirectRoute(currentAccount, currentOrganization, currentLocation, roles) :
    '/';

  navigate.to(mainPageRoute);
}

export function redirectToIndexPage(): void {
  return navigate.to('/');
}

export const ROUTES = {
  CAMPAIGN: {
    toDeliverablesContent: (
      campaignId: number,
      query?: {
        subcampaignId?: number | null,
        filter?: DeliverablesFilterCampaign | null
      } | null
    ): string => `/campaigns/${campaignId}/deliverables${query ? `?${Querystring.objectToString(query)}` : ''}`
  }
};

export const PAGE_TYPE = {
  ACCESS: 'access',
  EMPTY: 'empty',
  SHARED_ACCESS: 'shared_access',
  CONSUMER_INSIGHTS: 'consumer_insights'
};

export const shouldRedirectToAppStorePage = (
  location: LocationDeprecated
): boolean => (
  location?.query?.mobileRedirect === 'true'
);

export const redirectToCreatorsSearch = () => navigate.to('/content-creator/profiles');
export const redirectToAppStorePage = () => navigate.to('/app-store');
